import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "9",
  viewBox: "0 0 9 9"
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "translate(0.75 0.75)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.5,0,0,7.5",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M0,0,7.5,7.5",
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10",
      "stroke-width": "1.5"
    })
  ])
], -1)
const _hoisted_2 = { class: "drawer-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", null, "Configurator", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "See our dashboard options.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_6 = { class: "sidebar-color" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, "Sidebar Color", -1)
const _hoisted_8 = { class: "sidebar-color__row" }
const _hoisted_9 = { class: "sidebar-color sidebar-text-color" }
const _hoisted_10 = { class: "sidebar-color__row" }
const _hoisted_11 = { class: "sidebar-color sidebar-text-color" }
const _hoisted_12 = { class: "sidebar-color__row" }
const _hoisted_13 = { class: "sidenav-type" }
const _hoisted_14 = { class: "navbar-fixed" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h6", null, "Navbar Fixed", -1)
const _hoisted_16 = { class: "navbar-fixed" }

import { ref, onMounted, watch, toRefs } from 'vue'
import cookiesConFig from '@/utils/CookiesConfig'
import {
  SIDEBAR_COLOR,
  SIDEBAR_TEXT_COLOR,
  SIDEBAR_SELECTED_TEXT_COLOR,
  SIDENAV_TYPE,
  DARK_TYPE,
  NAVBAR_DARK_MODEL,
  NAVBAR_FIXED_MODEL,
} from '@/const/ConstCookies'

const DEFAULT_SIDEBAR_COLOR = 'primary'
const DEFAULT_SIDEBAR_TEXT_COLOR = 'primary'
const DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR = 'white'
const DEFAULT_SIDENAV_TYPE = true

interface Props {
  showSettingsDrawer: boolean
  sidebarColor: string
  sidebarTextColor: string
  sidebarSelectedTextColor: string
  sidenavType: boolean
  darkMode: boolean
  navbarFixed: boolean
  rtl: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardSettingsDrawer',
  props: {
    showSettingsDrawer: { type: Boolean },
    sidebarColor: { default: DEFAULT_SIDEBAR_COLOR },
    sidebarTextColor: { default: DEFAULT_SIDEBAR_TEXT_COLOR },
    sidebarSelectedTextColor: { default: DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR },
    sidenavType: { type: Boolean, default: DEFAULT_SIDENAV_TYPE },
    darkMode: { type: Boolean, default: false },
    navbarFixed: { type: Boolean, default: false },
    rtl: { type: Boolean, default: false }
  },
  emits: [
  'darkModel',
  'toggleNavbarPosition',
  'updateSidenavType',
  'updateSidebarColor',
  'updateSidebarTextColor',
  'updateSidebarSelectedTextColor',
  'toggleSettingsDrawer',
],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const { sidebarColor, sidebarTextColor, sidebarSelectedTextColor, sidenavType, darkMode } =
  toRefs(props)

const sidebarColorModel = ref(DEFAULT_SIDEBAR_COLOR)
const sidebarTextColorModel = ref(DEFAULT_SIDEBAR_TEXT_COLOR)
const sidebarSelectedTextColorModel = ref(DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR)
const sidenavTypeModel = ref(DEFAULT_SIDENAV_TYPE)
const navbarFixedModel = ref(false)
const navbarDarkModel = ref(false)

const applySidebarColor = (val: string) => {
  const color = val || DEFAULT_SIDEBAR_COLOR
  sidebarColorModel.value = color
  emits('updateSidebarColor', color)
}

const applySidebarTextColor = (val: string) => {
  const color = val || DEFAULT_SIDEBAR_TEXT_COLOR
  sidebarTextColorModel.value = color
  emits('updateSidebarTextColor', color)
}

const applySidebarSelectedTextColor = (val: string) => {
  const color = val || DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR
  sidebarSelectedTextColorModel.value = color
  emits('updateSidebarSelectedTextColor', color)
}

const onSidebarColorChange = (e: any) => {
  const val = e?.target?.value ?? sidebarColorModel.value
  applySidebarColor(val)
}

const onSidebarTextColorChange = (e: any) => {
  const val = e?.target?.value ?? sidebarTextColorModel.value
  applySidebarTextColor(val)
}

const onSidebarSelectedTextColorChange = (e: any) => {
  const val = e?.target?.value ?? sidebarSelectedTextColorModel.value
  applySidebarSelectedTextColor(val)
}

const onSidenavTypeChange = (val: boolean | string) => {
  const enabled = val === true || val === 'true'
  sidenavTypeModel.value = enabled
  emits('updateSidenavType', enabled)
}

const resetSidebarColor = () => {
  applySidebarColor(DEFAULT_SIDEBAR_COLOR)
}

const resetSidebarTextColor = () => {
  applySidebarTextColor(DEFAULT_SIDEBAR_TEXT_COLOR)
}

const resetSidebarSelectedTextColor = () => {
  applySidebarSelectedTextColor(DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR)
}

onMounted(() => {
  modelConfig()
})

watch(
  sidebarColor,
  (val) => {
    if (val) sidebarColorModel.value = val
  },
  { immediate: true }
)

watch(
  sidebarTextColor,
  (val) => {
    if (val) sidebarTextColorModel.value = val
  },
  { immediate: true }
)

watch(
  sidebarSelectedTextColor,
  (val) => {
    if (val) sidebarSelectedTextColorModel.value = val
  },
  { immediate: true }
)

watch(
  sidenavType,
  (val) => {
    sidenavTypeModel.value = !!val
  },
  { immediate: true }
)

watch(
  darkMode,
  (val) => {
    navbarDarkModel.value = !!val
  },
  { immediate: true }
)

const toggleDarkModel = (val?: boolean | string) => {
  const enabled =
    typeof val === 'boolean' ? val : val === 'true' ? true : !!navbarDarkModel.value
  navbarDarkModel.value = enabled
  cookiesConFig.setCokies(NAVBAR_DARK_MODEL, enabled)
  cookiesConFig.setCokies(DARK_TYPE, enabled ? 'dark-mode' : '')
  emits('darkModel', enabled ? 'dark-mode' : '')
}

const toggleNavbar = (val: any) => {
  cookiesConFig.setCokies(NAVBAR_FIXED_MODEL, val)
  emits('toggleNavbarPosition', val)
}

const toggleSettingsDrawer = (val: any) => {
  emits('toggleSettingsDrawer', val)
}

const readSidenavType = () => {
  const raw = cookiesConFig.getCokies(SIDENAV_TYPE)
  if (raw === '' || raw === null || raw === undefined) return DEFAULT_SIDENAV_TYPE
  return raw === 'true' || raw === true
}

const readDarkMode = () => {
  const darkType = cookiesConFig.getCokies(DARK_TYPE)
  if (darkType === 'dark-mode') return true
  return cookiesConFig.getCokiesBoolean(NAVBAR_DARK_MODEL)
}

const modelConfig = () => {
  const savedColor = cookiesConFig.getCokies(SIDEBAR_COLOR)
  const savedTextColor = cookiesConFig.getCokies(SIDEBAR_TEXT_COLOR)
  const savedSelectedTextColor = cookiesConFig.getCokies(SIDEBAR_SELECTED_TEXT_COLOR)
  sidebarColorModel.value = savedColor || props.sidebarColor || DEFAULT_SIDEBAR_COLOR
  sidebarTextColorModel.value =
    savedTextColor || props.sidebarTextColor || DEFAULT_SIDEBAR_TEXT_COLOR
  sidebarSelectedTextColorModel.value =
    savedSelectedTextColor ||
    props.sidebarSelectedTextColor ||
    DEFAULT_SIDEBAR_SELECTED_TEXT_COLOR
  sidenavTypeModel.value =
    props.sidenavType !== undefined ? !!props.sidenavType : readSidenavType()
  navbarFixedModel.value = cookiesConFig.getCokiesBoolean(NAVBAR_FIXED_MODEL)
  navbarDarkModel.value = props.darkMode || readDarkMode()
}

return (_ctx: any,_cache: any) => {
  const _component_h_button = _resolveComponent("h-button")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_h_radio = _resolveComponent("h-radio")!
  const _component_h_switch = _resolveComponent("h-switch")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    class: _normalizeClass(["settings-drawer", [_ctx.rtl ? 'settings-drawer-rtl' : '']]),
    placement: _ctx.rtl ? 'left' : 'right',
    closable: false,
    visible: _ctx.showSettingsDrawer,
    width: 360,
    onClose: _cache[8] || (_cache[8] = ($event: any) => (toggleSettingsDrawer(false)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_h_button, {
        type: "link",
        class: "btn-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleSettingsDrawer(false)))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_h_radio, {
              modelValue: sidebarColorModel.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sidebarColorModel).value = $event)),
              onChange: onSidebarColorChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, {
                  value: "primary",
                  class: "bg-primary"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "secondary",
                  class: "bg-secondary"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "success",
                  class: "bg-success"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "danger",
                  class: "bg-danger"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "warning",
                  class: "bg-warning"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "black",
                  class: "bg-dark"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-sidebar-default",
              onClick: resetSidebarColor
            }, _toDisplayString(_ctx.$t('config.defaultColor')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('config.sidebarTextColor')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_h_radio, {
              modelValue: sidebarTextColorModel.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((sidebarTextColorModel).value = $event)),
              onChange: onSidebarTextColorChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, {
                  value: "primary",
                  class: "bg-primary"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "white",
                  class: "bg-white"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "secondary",
                  class: "bg-secondary"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "success",
                  class: "bg-success"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "danger",
                  class: "bg-danger"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "warning",
                  class: "bg-warning"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "black",
                  class: "bg-dark"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-sidebar-default",
              onClick: resetSidebarTextColor
            }, _toDisplayString(_ctx.$t('config.defaultColor')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('config.textSelectedColor')), 1),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_h_radio, {
              modelValue: sidebarSelectedTextColorModel.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sidebarSelectedTextColorModel).value = $event)),
              onChange: onSidebarSelectedTextColorChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_button, {
                  value: "primary",
                  class: "bg-primary"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "white",
                  class: "bg-white"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "secondary",
                  class: "bg-secondary"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "success",
                  class: "bg-success"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "danger",
                  class: "bg-danger"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "warning",
                  class: "bg-warning"
                }),
                _createVNode(_component_a_radio_button, {
                  value: "black",
                  class: "bg-dark"
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-sidebar-default",
              onClick: resetSidebarSelectedTextColor
            }, _toDisplayString(_ctx.$t('config.defaultColor')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('config.sidenavType')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('config.sidenavTypeHint')), 1),
          _createVNode(_component_h_switch, {
            modelValue: sidenavTypeModel.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sidenavTypeModel).value = $event)),
            onChange: onSidenavTypeChange
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_h_switch, {
            modelValue: navbarFixedModel.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((navbarFixedModel).value = $event)),
            onChange: _cache[6] || (_cache[6] = ($event: any) => (toggleNavbar(navbarFixedModel.value)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('config.darkTheme')), 1),
          _createVNode(_component_h_switch, {
            modelValue: navbarDarkModel.value,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((navbarDarkModel).value = $event)),
            onChange: toggleDarkModel
          }, null, 8, ["modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["class", "placement", "visible"]))
}
}

})